module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/symbol-observable/index.js
// module id = 1239
// module chunks = 0